// extracted by mini-css-extract-plugin
export default {"nav_menu-dropdown":"CatDropList_nav_menu-dropdown__YRHKt","root_menu":"CatDropList_root_menu__kRD2b","sub_menu":"CatDropList_sub_menu__h7wqc"};